<dx-drawer
    data-testid="tasks-drawer"
    [position]="selectedPosition"
    [revealMode]="selectedRevealMode"
    [openedStateMode]="openedStateMode"
    [maxSize]="drawerMaxSize"
    [closeOnOutsideClick]="false"
    [(opened)]="isDrawerOpen"
    [shading]="false"
    [height]="'100%'"
    class="dx-drawer"
    template="template"
    >
    <div *dxTemplate="let data of 'template'" data-testid="drawer-template" class="drawer-template">
        <div class="detail-container" data-testid="detail-container">
            <app-task-detail
            data-testid="task-detail-component"
            *ngIf = "isDrawerOpen"
                (closePanelEmitter)="closePanel()"
                (refreshEmitter)="LoadTaskData()"
              (commentPostedEmitter)="onTaskCommentPosted($event)"
                [selectedTask]="selectedTask"
                [selectedSectionIndex]="selectedSectionIndex"
                [isEditable]="isEditable"
                [isCompleteable]="isCompleteable"
                [isTaskDetailLoaded]="isTaskDetailLoaded"
                >
            </app-task-detail>
        </div>
    </div>
    <!-- <dx-scroll-view data-testid="tasks-scroll-view" [height]="'100%'" [width]="'100%'" [useNative]="true" [bounceEnabled]="false" [scrollByContent]="true" [scrollByThumb]="true" [showScrollbar]="'onHover'"> -->
    <div class="container" data-testid="tasks-container">


      <data-grid data-testid="tasks-data-grid" id="dataGridTasks" #dataGrid [rowData]="dataSource" [columnData]="taskColumnData" [childColumnData]="subTaskColumnData" [deals]="deals" [refreshMode]="refreshMode" [addNewText]="addNewText" [gridHeight]="'calc(100vh - 260px)'"
      [allowEditing]="false" (editorPreparing)="onEditorPreparing($event)" (rowSelectionChangedEmitter)="onRowSelectionChanged($event)"
      (detailRowSelectionChangedEmitter)="onDetailRowSelectionChanged($event)"
      (onRowDblClickEmitter)="onRowDblClick($event)" (onRowClickEmitter)="onRowClick($event)" [storageKey]="gridStorageKey"  (onCheckboxChangedEmitter)="onMyTasksChanged($event)" (onCheckbox1ChangedEmitter)="showCompletedChanged($event)"
      (onCheckbox2ChangedEmitter)="showRejectedChanged($event)"
      (onContextMenuPreparingEmitter)="onContextMenuPreparing($event)"
      (onCellPreparedEventEmitter)="onCellPrepared($event)"
      (onContentReadyEmitter)="onGridContentReady($event)"
      [detailRowHighlightPredicate]="isSubtasksWithAttachmentsSelected ? subtaskHighlightPredicate : null"
      [rowHighlightPredicate]="urgentVoucherRowHighlightPredicate"
      [isRowSelectable]="isTaskRowSelectable"
      (onAddNewEmitter) = "onAddNew($event)"  [gridFilterOptions] = "gridFilterOptions"
      (onFilterEmitter) = "onDateFilter($event)" [hasMasterDetail]="true" childPropertyKey="subTasks"
      (onDetailContextMenuPreparingEmitter)="onContextMenuPreparing($event)"
      (onDetailRowDblClickEmitter)="onDetailRowDblClick($event)" (onDetailRowClickEmitter)="onDetailRowClick($event)" [addNewOptions]="taskTemplates" (onExportingToExcelEmitter)="onExportToExcel($event)"
      [showSearchPanel] = "showSearchPanel" [showFilterRow]="true" [searchPlaceholder]="searchPlaceholderText" tasksCheckboxText="My Tasks"
      [radioGroupValue]="radioGroupValue" [cacheEnabled]="false" (selectedRowKeys)="selectedRowKeys"
      [showExportToExcel]="true"
      [datagridButtons]="datagridButtons"
      [isButtonVisible]="isButtonVisible"
      checkbox1Text="Show Completed" [checkbox1Value]="showCompleted"  [checkbox1Visible]="true"
      checkbox2Text="Show Rejected" [checkbox2Value]="showRejected" [checkbox2Visible]="true"
      selectBoxLabel="Selected View" [selectBoxItems]="viewOptions" [selectBoxValue]="selectedView" [selectBoxVisible]="true"
      (onSelectBoxChangedEmitter)="onSelectedViewChanged($event)"
      (onButtonClickedEmitter)="onDataGridButtonClick($event)" [isButtonDisabled]="isButtonDisabled"
      [getButtonHint]="getButtonHint"
      [getButtonClass]="getButtonClass"
      [getButtonIcon]="getButtonIcon"
      [currencyFormatter]="getFormattedAmount"
      [getAmountTooltip]="getAmountTooltip"
      [getAmountCellClass]="getAmountCellClass"
      [isUrgentDueDateRow]="isUrgentDueDateRow"
      [showAddNew]="true"
      [showFilterRow]="true"
      [filteredExternally]="filteredByDashboardTaskIds" [filteredExternallyMessage]="filteredExternallyMessage" (onExternalFilterDismissedEmitter)="onExternalFilterDismissed()"
      ></data-grid>

      <!-- Card view: replaces the grid table at < 1024px. The outer toolbar
           (Due/Scope filters, Add New, overflow) remains visible because only
           .fixed-header-grid is hidden by the CSS in data-grid.component.scss.
           Shares the same CustomStore dataSource so all active filters apply. -->
      <div class="task-card-list-container" *ngIf="isCardView" data-testid="tasks-card-list-container">
        <dx-list
          #cardList
          data-testid="tasks-card-list"
          [dataSource]="dataSource"
          pageLoadMode="nextButton"
          nextButtonText="Load more tasks"
          [selectionMode]="'none'"
          [showSelectionControls]="false"
          [pullRefreshEnabled]="false"
          [bounceEnabled]="false"
          itemTemplate="cardTemplate">
          <div *dxTemplate="let task of 'cardTemplate'">
            <div class="task-card"
                 data-testid="task-card-item"
                (click)="onCardTap(task, $event)"
                 [class.task-card--urgent]="urgentVoucherRowHighlightPredicate(task)">
              <div class="task-card__header">
                <span class="task-card__id">{{ task.taskId }}</span>
                <span class="task-card__badge" [ngClass]="getCardStatusClass(task.status)">{{ task.status }}</span>
              </div>
              <div class="task-card__body">
                <div class="task-card__field" *ngIf="task.taskType">
                  <span class="task-card__label">Type:</span>
                  <span class="task-card__value">{{ task.taskType }}</span>
                </div>
                <div class="task-card__field" *ngIf="task.dueDate">
                  <span class="task-card__label">Due:</span>
                  <span class="task-card__value" [ngClass]="getCardDueDateClass(task)">
                    {{ task.dueDate | date:dateDisplayFormat }}
                  </span>
                </div>
                <div class="task-card__field" *ngIf="task.assignedUserName">
                  <span class="task-card__label">Assigned:</span>
                  <span class="task-card__value">{{ task.assignedUserName }}</span>
                </div>
              </div>
            </div>
          </div>
        </dx-list>
      </div>

   </div>
  <!-- </dx-scroll-view> -->
</dx-drawer>

<dx-load-panel
  data-testid="tasks-load-panel"
  container=".container"
  [position]="{ of: '.content' }"
  [visible]="isLoading"
  [showPane]="true"
  [showIndicator]="true"
  width="150"
  height="150"
  [shading]="true"
  shadingColor="rgba(0,0,0,0.1)"
  [wrapperAttr]="{ class: 'tasks-spinner-only' }"
></dx-load-panel>

<dx-popup
    data-testid="new-task-popup"
    [height]="newTaskPopupHeight"
    [width]="newTaskPopupWidth"
    [title]="addNewTemplateType"
    position= "center"
    [showCloseButton] = "true"
    id="newTask"
    [resizeEnabled]= "true"
    [(visible)]="addNewTaskVisible"
    contentTemplate="popupContent"
    (onHiding)="onNewTaskPopupHiding($event)"
    >

    <div *dxTemplate="let data of 'popupContent'" data-testid="new-task-popup-content">
      <app-new-task data-testid="new-task-component" *ngIf="addNewTaskVisible"
      [taskTemplateName]="templateName"
      [taskMetadata]="taskMetadata"
      [addNewTemplateType] ="addNewTemplateType"
      [task] = "selectedTask"
      (onAddNewTaskEventEmitter)="onAddNewTask($event)"
      >
      </app-new-task>
    </div>


</dx-popup>



<dx-popup #userPopup
    data-testid="user-lookup-popup"
    height="85"
    width="500"
    position= "center"
    [showCloseButton] = "false"
    [showTitle]="false"
    id="unAssignedUserLookup"
    [(visible)]="assignedUserPopupVisible"
    contentTemplate="popupContent"
    [hideOnOutsideClick]="true"
    >

    <div *dxTemplate="let data of 'popupContent'" data-testid="user-lookup-popup-content">
      <dx-lookup #lookup
      data-testid="user-lookup"
      [dataSource]="teamUsers"
      placeholder="Search for a user"
      displayExpr="name"
      valueExpr=""
      (onValueChanged)="onAssignedUserSelected($event)"
      [searchEnabled] = "true" >
    </dx-lookup>
    </div>



</dx-popup>

<dx-popup #commentsPopUp
    data-testid="comments-popup"
    height="300"
    width="500"
    position="center"
    [showCloseButton]="false"
    [showTitle]="true"
    title="Add a comment"
    id="commentsPopUp"
    [(visible)]="showCommentsVisible"
    contentTemplate="commentsContent"
    [hideOnOutsideClick]="true"
>
  <div *dxTemplate="let data of 'commentsContent'" data-testid="comments-popup-content">
    <app-comment
      data-testid="comment-component"
      [placeholder]="'Add a comment...'"
      (closePanelEmitter)="onCommentClosing($event)"
      (onCommentEmitter)="onCancelTasks($event)">
    </app-comment>
  </div>
</dx-popup>
<dx-popup #rejectTasksPopUp
    data-testid="reject-tasks-popup"
    height="650"
    width="500"
    position="center"
    [showCloseButton]="false"
    [showTitle]="true"
    title="Select a task to rollback to"
    id="rejectTasksPopUp"
    [(visible)]="rejectTasksPopupVisible"
    contentTemplate="rejectTasksContent"
    [hideOnOutsideClick]="true"
>
  <div *dxTemplate="let data of 'rejectTasksContent'" data-testid="reject-tasks-popup-content">
    <app-reject-tasks
      data-testid="reject-tasks-component"
      #rejectTasksComponent
      [rollbackTasks]="rollbackTasks"
      (closePanelEmitter)="onRejectTasksClosing($event)"
      (onRejectEmitter)="onReject($event)">
    </app-reject-tasks>
  </div>
</dx-popup>

<dx-popup #blockTaskPopUp
    data-testid="hold-task-popup"
    height="400"
    width="500"
    position="center"
    [showCloseButton]="false"
    [showTitle]="true"
    [title]="getHoldTaskPopupTitle()"
    id="blockTaskPopUp"
    [(visible)]="holdTaskPopupVisible"
    contentTemplate="holdTaskContent"
    [hideOnOutsideClick]="true"
>
  <div *dxTemplate="let data of 'holdTaskContent'" data-testid="hold-task-popup-content">
    <app-hold-task
      data-testid="hold-task-component"
      #holdTaskComponent
      [holdTask]="holdTask"
      (closePanelEmitter)="onHoldTaskClosing($event)"
      (onHoldEmitter)="onHold($event)">
    </app-hold-task>
  </div>
</dx-popup>